import React, {useEffect,useState} from 'react';
import DataTable from 'react-data-table-component';
import axios from 'axios';
import {FormControl , TextField, Grid ,Tooltip,IconButton, Box, Card, CardContent , Typography,CardActions,Button } from '@mui/material/';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { DataGrid, GridToolbar,frFR  } from '@mui/x-data-grid';
import DialogTitle from '@mui/material/DialogTitle';
import Autorize from '../../components/ui/autorize';
import Member from '../../components/members/member';
import Cookies from 'js-cookie'
import { getSessionValide ,getUserRule,getSessionExpirer } from '../../utils/userRule';
//https://react-data-table-component.netlify.app/?path=/docs/examples-filtering--filtering


function Memberslist({clubid,secteur,ruleWrite}) {
    
        
    const [ruleRead, setRuleRead] = useState(""); 
    const [sessionValide, setSessionValide] = useState(""); 
    const [errorAxios, setErrorAxios] = useState(false);
    const [memberslist, setMemberslist] = useState([]);
    const [memberSelect, setMemberSelect] = useState("");
    const [modalOpen, setModalOpen] = useState(false);
    const [memberid, setMemberid] = useState("");


  /*
    const MyAxios = axios.create({
        headers: { 'Access-Control-Allow-Origin':  process.env.REACT_APP_API},       
        withCredentials: true,
        xsrfCookieName: 'token',
        xsrfHeaderName: 'X-XSRF-TOKEN',
    })*/
const MyAxios = axios.create({    
    headers: { Authorization: "Bearer "+ Cookies.get('token'),
            }      
})


  
    useEffect(() => {
        
        const fetchData = async () => {
            try {
                    let RuleRead_member = await getUserRule("read_member",clubid,secteur);
                    setRuleRead(RuleRead_member);
                   // setSessionValide(getSessionExpirer());

                
                    if(clubid !== "" && RuleRead_member === true)
                    {
                        LoadData();
                    }
                } catch (error) {
                    console.error('Une erreur s\'est produite lors de la récupération des données', error);
                  }
        };      
        fetchData(); // Appel de la fonction asynchrone
      


    },[clubid]);


    function LoadData()
    {
      
        //console.log(process.env.REACT_APP_API + '/members/get/secteur/'+ secteur +'/club/'+ clubid+ '/actifonly/false');
        MyAxios.get(process.env.REACT_APP_API + '/members/get/secteur/'+ secteur +'/club/'+ clubid+ '/actifonly/false')
        .then((res) => {                
            setMemberslist(res.data);   
        })
        .catch((error) => {
            setErrorAxios(true);
        });

    }





    function closeModal() {
        setModalOpen(false);
        LoadData();
    }
    
    function openModal() {
        setModalOpen(true);
    }

  
    const AddNewMembre = () => {        
        setMemberid("new");        
        openModal();
    };

    const onRowClicked = (row, event) => {        
        setMemberid(row.id);        
        openModal();
    };


        const columns = [           
            {      field: 'id',            headerName: 'id' ,        width: 0 ,     hide: true}  ,
            {      field: 'memberId',      headerName: 'No de membre' ,    width: 130 ,    }  ,         
            {      field: 'First_Name',     headerName: 'Prénom' ,  width: 120 ,     }  ,
            {      field: 'Last_Name',     headerName: 'Nom de famille' ,    width: 120 ,   }  ,               
            {      field: 'E_Mail_Address',        headerName: 'Courriel' ,    width: 230 ,      }  ,
            {      field: 'Home_Phone_Number',        headerName: 'Téléphone maison' ,   width: 200 ,       }  ,
            {      field: 'Cell_Phone_Number',        headerName: 'Téléphone cellulaire' ,   width: 200 ,       }  ,             
            {      field: 'Address',        headerName: 'Adresse' ,   width: 200 ,       }  ,           
            {      field: 'City',        headerName: 'Ville' ,   width: 200 ,       }  ,
            {      field: 'Province',        headerName: 'Province' ,   width: 200 ,   }  ,   
            {      field: 'Postal_Code',        headerName: 'Code postal' ,   width: 200 ,       }  ,     
            {      field: 'CollegeMbr',        headerName: 'Membre collégial' ,   width: 200 ,   }  , 
            {      field: 'Life_Membership_Date_Effective',        headerName: 'Membre à vie' ,   width: 200 ,   }  ,           
            {      field: 'DateAjout',        headerName: "Date d'ajout" ,       width: 200 ,   }  ,
            {      field: 'DateRadiation',        headerName: 'Date radiation' ,       width: 200 ,   }  ,
          
        ];


        
 return (
        <div>
            <Autorize axiosError={errorAxios} sessionExpirer={sessionValide} ruleAcces={ruleRead} />
            {getMain()}
        </div>
    );  


    function getButtonAddSave()
    {
       if(ruleWrite === true)
           return( <Button onClick={AddNewMembre} variant="containedFifth">Ajouter un membre</Button>  );
    }

function getMain()
{

    if(ruleRead === true)
    { 

        return (
            <div >


                 <Grid container direction="row" spacing={2}>
                    <Grid item xs={1}> 
                        <Typography variant="h6" gutterBottom>Membrariat</Typography>
                    </Grid>
                    <Grid item xs={3}> 
                           {getButtonAddSave()}         
                    </Grid> 
                </Grid>


                   
                        <div style={{ height: 600, }}>
                            <DataGrid key="DataGridMember"   localeText={frFR.components.MuiDataGrid.defaultProps.localeText}
                                rows={memberslist}
                                columns={columns}
                               
                              
                                onRowClick={(rowData) => onRowClicked(rowData.row)}
                                components={{ Toolbar: GridToolbar }} 
                                initialState={{
                                    filter: {
                                      filterModel: {
                                        items: [{ columnField: 'DateRadiation', operatorValue:  'isEmpty' }],
                                      },
                                    },
                                  }}
                                
                            />
                        </div>               
               

                <Dialog key="DdialogMember"
                    sx={{ '& .MuiDialog-paper': { maxWidth: '90%', maxHeight: '90%' } }}
                    maxWidth="xs"                 
                    open={modalOpen}                
                    >
                    <DialogTitle>Fiche du membre</DialogTitle>
                        <DialogContent dividers>
                        <Member memberid={memberid} clubid={clubid} secteur={secteur} ruleWrite={ruleWrite}/>
                    </DialogContent>

                    <DialogActions>
                        <Button variant="containedSecondary" onClick={closeModal}>Fermer               
                    </Button>

                    </DialogActions>
                </Dialog>



        </div>
       

        );
    }
}

}

export default Memberslist;